import React, { useContext } from "react";
import { QuestionContext } from "../../context";
import { Checkbox } from "antd";
import { RichText } from "../RichText";
import classNames from "classnames";
import "./index.scss";

export function OptionsMulti({ className, style }: RenderComponent) {
    const ctx = useContext(QuestionContext);
    if (ctx.type !== "MultiChoice") throw new Error("error type data");

    return (
        <Checkbox.Group
            value={ctx.data.answer}
            className={classNames("QuestionOptionsMulti", className)}
            style={style}>
            {ctx.data.options.map((item, index) => (
                <Checkbox key={item.id} value={item.id}>
                    <RichText>{`${String.fromCharCode(65 + index)}.  ${
                        item.content
                    }`}</RichText>
                </Checkbox>
            ))}
        </Checkbox.Group>
    );
}
